import {Zoom} from '@mui/material';
import Paper from '@mui/material/Paper';
import React, {useState} from 'react';
import {observer} from 'mobx-react';
import Box from "../Common/Box";
import ControlButton from "../Common/ControlButton";
import MessageOutlined from "@mui/icons-material/MessageOutlined";
import uiStore from "../lib/stores/uiStore";

interface Props {
    right?: string,
    left?: string,
    top?: string,
}

export default observer(function ManagerButtons(
        {

            right,
            left,
            top,
        }: Props) {

    const [overlayVisible, setOverlayVisible] = useState(false);

    return <Box
            zIndex={10000000}
            row
            padding={"10px"}
            position={"absolute"}
            bottom={"70px"}
            right={right}
            left={left}
            top={top}
            style={{
                pointerEvents: "none"
            }}
            onMouseLeave={() => {
                setOverlayVisible(false)
            }}
    >
        <Box
                style={{
                    position: "relative",
                }}
        >
            <Box
                    style={{
                        pointerEvents: "all",
                        width: "50%",
                        position: "absolute",
                        height: "100%",
                    }}
                    onMouseOver={() => {
                        setOverlayVisible(true)
                    }}
            />
            <Zoom in={overlayVisible}>
                <Paper elevation={4} style={{
                    display: "flex",
                    padding: "10px",
                    position: "relative",
                    pointerEvents: overlayVisible ? "all" : "none"
                }}>


                    <ControlButton
                            // sx={{marginLeft: "20px"}}
                            width={35}
                            enabled={uiStore.managerFocused}
                            icon={MessageOutlined}
                            onClick={() => {
                                uiStore.managerFocused = !uiStore.managerFocused;
                            }}
                    />
                </Paper>
            </Zoom>
        </Box>
    </Box>
});
